// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const VEHICLE_BASE_URL = '/api/v1/wechat/vehicle';

/**
 * 获取公用车审批流程列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getVehicleApplicationList(
  params?: OA.VehicleApplicationListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.VehicleApplicationListData>>(
    `${VEHICLE_BASE_URL}/applications`,
    {
      method: 'GET',
      params: params || {},
      ...(options || {}),
    },
  );
}

/**
 * 获取公车归还记录详情
 * @param vehicleSpNo 公车申请流程的审批单号
 * @param options 请求配置
 */
export async function getVehicleReturnDetail(
  vehicleSpNo: string,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.VehicleReturnDetailData>>(
    `${VEHICLE_BASE_URL}/return-detail/${vehicleSpNo}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 获取加油记录列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getRefuelRecordList(
  params?: OA.RefuelRecordListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.RefuelRecordListData>>(
    `${VEHICLE_BASE_URL}/refuel-records`,
    {
      method: 'GET',
      params: params || {},
      ...(options || {}),
    },
  );
}

/**
 * 获取加油统计信息
 * @param options 请求配置
 */
export async function getRefuelStatistics(
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.RefuelStatistics[]>>(
    `${VEHICLE_BASE_URL}/refuel-statistics`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 导出加油记录
 * @param params 查询参数
 * @param options 请求配置
 */
export async function exportRefuelRecords(
  params: { year: number; month: number },
  options?: { [key: string]: any },
) {
  return request<Blob>(
    `${VEHICLE_BASE_URL}/refuel-records/export`,
    {
      method: 'GET',
      params,
      responseType: 'blob',
      ...(options || {}),
    },
  );
}

/**
 * 导出用车记录
 * @param params 查询参数
 * @param options 请求配置
 */
export async function exportUseRecords(
  params: { year: number; month: number },
  options?: { [key: string]: any },
) {
  return request<Blob>(
    `${VEHICLE_BASE_URL}/use-records/export`,
    {
      method: 'GET',
      params,
      responseType: 'blob',
      ...(options || {}),
    },
  );
}

/**
 * 获取车辆维修申请列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getVehicleRepairApplicationList(
  params?: OA.VehicleRepairApplicationListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.VehicleRepairApplicationListData>>(
    `${VEHICLE_BASE_URL}/repair-applications`,
    {
      method: 'GET',
      params: params || {},
      ...(options || {}),
    },
  );
}

/**
 * 修改公车归还记录
 * @param vehicleSpNo 公车申请流程的审批单号
 * @param data 修改参数
 * @param options 请求配置
 */
export async function updateVehicleReturnRecord(
  vehicleSpNo: string,
  data: OA.UpdateVehicleReturnParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.VehicleReturnInfo>>(
    `${VEHICLE_BASE_URL}/return-record/${vehicleSpNo}`,
    {
      method: 'PUT',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 创建车辆负责人
 * @param data 创建参数
 * @param options 请求配置
 */
export async function createVehicleManager(
  data: OA.CreateVehicleManagerParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.VehicleManager>>(
    `${VEHICLE_BASE_URL}/managers`,
    {
      method: 'POST',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 获取所有车辆负责人
 * @param options 请求配置
 */
export async function getVehicleManagerList(
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.VehicleManager[]>>(
    `${VEHICLE_BASE_URL}/managers`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 获取指定车辆的负责人
 * @param vehiclePlate 车牌号（需URL编码）
 * @param options 请求配置
 */
export async function getVehicleManager(
  vehiclePlate: string,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.VehicleManager>>(
    `${VEHICLE_BASE_URL}/managers/${encodeURIComponent(vehiclePlate)}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 更新车辆负责人
 * @param vehiclePlate 车牌号（需URL编码）
 * @param data 更新参数
 * @param options 请求配置
 */
export async function updateVehicleManager(
  vehiclePlate: string,
  data: OA.UpdateVehicleManagerParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.VehicleManager>>(
    `${VEHICLE_BASE_URL}/managers/${encodeURIComponent(vehiclePlate)}`,
    {
      method: 'PUT',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 删除车辆负责人
 * @param vehiclePlate 车牌号（需URL编码）
 * @param options 请求配置
 */
export async function deleteVehicleManager(
  vehiclePlate: string,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<any>>(
    `${VEHICLE_BASE_URL}/managers/${encodeURIComponent(vehiclePlate)}`,
    {
      method: 'DELETE',
      ...(options || {}),
    },
  );
}

/**
 * 获取车牌号列表
 * @param options 请求配置
 */
export async function getVehiclePlates(
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.VehiclePlatesData>>(
    `${VEHICLE_BASE_URL}/plates`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 删除加油记录
 * @param recordId 加油记录ID
 * @param options 请求配置
 */
export async function deleteRefuelRecord(
  recordId: number,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<any>>(
    `${VEHICLE_BASE_URL}/refuel-records/${recordId}`,
    {
      method: 'DELETE',
      ...(options || {}),
    },
  );
}

/**
 * 修改加油记录
 * @param recordId 加油记录ID
 * @param data 修改参数
 * @param options 请求配置
 */
export async function updateRefuelRecord(
  recordId: number,
  data: OA.UpdateRefuelRecordParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.RefuelRecord>>(
    `${VEHICLE_BASE_URL}/refuel-records/${recordId}`,
    {
      method: 'PUT',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 获取里程异常记录列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getMileageAnomalies(
  params?: OA.MileageAnomalyListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.MileageAnomalyListData>>(
    `${VEHICLE_BASE_URL}/mileage-anomalies`,
    {
      method: 'GET',
      params: params || {},
      ...(options || {}),
    },
  );
}

